import { concatIfEmpty } from "./concatIfEmpty";
export const defaultObservableIfEmpty = concatIfEmpty;
export const switchIfEmpty = concatIfEmpty;
//# sourceMappingURL=defaultObservableIfEmpty.js.map